// @view/writing/review/SectionList.tsx
import EmptyView from "@view/EmptyView";
import React from "react";
import { useDocumentContext } from "@contexts/Document.context";
import Section from "./Section";
import type { DocumentReviewViewProps } from "@ps-bridge/contracts/documentReview";
import * as Option from "@utils/Option";
import * as styles from "@styles/SectionList.css";

type SectionListProps = Pick<DocumentReviewViewProps, "handleRefine" | "handleEdits" | "handleDraft" | "handleUpload">;

const SectionList: React.FC<SectionListProps> = ({
  handleRefine,
  handleEdits,
  handleDraft,
  handleUpload
}) => {
  const { document, activeSection } = useDocumentContext();

  return Option.fold(
    document.read,
    () => <EmptyView />,
    (documentValue) => {
      const sortedSections = [...documentValue.document_contents].sort(
        (a, b) => a.metadata.index - b.metadata.index
      );
      return (
        <div className={styles.list}>
          {sortedSections.map((item) => (
            <Section
              key={item.metadata.id}
              section={item}
              active={Option.fold(
                activeSection.read,
                () => false,
                (value) => value === item.metadata.id
              )}
              handleRefine={handleRefine}
              handleEdits={handleEdits}
              handleDraft={handleDraft}
              handleUpload={handleUpload}
              setActiveSection={activeSection.setSome}
            />
          ))}
        </div>
      );
    }
  );
};

export default SectionList;
